import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const PositioningSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const positioningContent = content[language].positioning;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="positioning" 
      ref={sectionRef}
      className="section"
      style={{ background: '#ffffff' }}
    >
      <div className="container">
        {/* Header */}
        <div className={`text-center mb-80 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2>{positioningContent.title}</h2>
        </div>

        {/* Factors Grid */}
        <div className="grid-3">
          {positioningContent.factors.map((factor, index) => (
            <div
              key={factor.title}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '40px 32px',
                background: 'var(--ivory)',
                transitionDelay: `${0.2 + index * 0.15}s`
              }}
            >
              <h4 className="mb-24" style={{ fontSize: '1.25rem', color: 'var(--olive)' }}>
                {factor.title}
              </h4>
              <p style={{ fontSize: '0.9375rem' }}>{factor.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PositioningSection;
